import { MouseEvent } from "react";

export function requestingNewTab(event: MouseEvent<Element>): boolean {
  return event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1;
}
